export default __webpack_public_path__ + "static/media/enghien11.5801eaa9.jpg";